import React, { useCallback, useEffect, useState } from 'react';
import {
  faBuildings,
  faSignalStream,
  faCalendarCircleExclamation,
  faArrowDownShortWide,
  faBriefcase,
  faHandHeart,
} from '@fortawesome/pro-light-svg-icons';
import { useUserActions } from 'shared/auth/hooks/useUserActions';
import FeedbackFilterDropdown from './FeedbackFilterDropdown';
import FeedbackDashboardAppliedFilters, {
  FeedbackDashboardAppliedFiltersProps,
} from '../FeedbackDashboardAppliedFilters';
import LoadAndSaveFilters from './LoadAndSaveFilters';
import { ApplyFilters } from './ShowFilter';
import FeedbackSingleSelectFilter from './FeedbackSingleSelectFilter';

interface FiltersBar extends FeedbackDashboardAppliedFiltersProps {
  type: 'donor' | 'TI staff';
  anyFiltersApplied: boolean;
  handleClearAllFilters: () => unknown;
  handleApplyAllFilters: (filters: ApplyFilters) => unknown;
}

const FiltersBar: React.FC<FiltersBar> = ({
  type,
  donorNames,
  relationships,
  portfolioNames,
  cycles,
  status,
  trueImpactStaff,
  dueDates,
  charityNavigator,
  years,
  sortBy,
  anyFiltersApplied,
  handleClearAllFilters,
  handleApplyAllFilters,
}) => {
  const { isAdmin } = useUserActions();
  const isDonor = type !== 'TI staff';
  const isManagerFilters = Object.keys(relationships.filters).length !== 0;
  const isPortfolioFilters = Object.keys(portfolioNames.filters).length !== 0;
  const [hasMore, setHasMore] = useState<boolean>(true);
  const [pageNumber, setPageNumber] = useState<number>(1);
  useEffect(() => {
    setHasMore(donorNames !== null);
  }, [donorNames, setHasMore]);
  const loadMore = useCallback(() => {
      setPageNumber(p => p + 1);
    }, [setPageNumber]);
  return (
    <div className="filter_bar__wrapper">
      <div className="heading-label">Filters</div>
      <div className="filter_selectors">
        <div className="filter_input__wrapper">
          {isManagerFilters && (
            <FeedbackFilterDropdown
              feedbackFilter={relationships}
              showSearchBox={true}
              icon={faBuildings}
              label="Relationship Manager"
            />
          )}
          <FeedbackFilterDropdown
            feedbackFilter={donorNames}
            showSearchBox={true}
            icon={faBuildings}
            label="Donor"
          />
          {isPortfolioFilters && (
            <FeedbackFilterDropdown
              feedbackFilter={portfolioNames}
              showSearchBox={true}
              icon={faBriefcase}
              label="Portfolio Names"
            />
          )}
          {/* {type === 'TI staff' && (
            <FeedbackFilterDropdown
              feedbackFilter={cycles}
              showSearchBox={false}
              icon={faGrid2}
              label="Feedback Cycle Type"
            />
          )} */}
          <FeedbackFilterDropdown
            feedbackFilter={status}
            showSearchBox={false}
            icon={faSignalStream}
            label="Status"

          />
          {/* <FeedbackFilterDropdown
            feedbackFilter={trueImpactStaff}
            showSearchBox={false}
            icon={faUserLarge}
            label="True Impact Staff"
          /> */}
          <FeedbackSingleSelectFilter
            showClearAll={true}
            feedbackFilter={dueDates}
            icon={faCalendarCircleExclamation}
            defaultValue="Due Date"
          />
          {isAdmin && (
            <FeedbackFilterDropdown
              feedbackFilter={charityNavigator}
              showSearchBox={false}
              icon={faHandHeart}
              label="Charity Navigator"
            />
          )}
          <FeedbackFilterDropdown
            feedbackFilter={years}
            showSearchBox={true}
            range
            icon={faCalendarCircleExclamation}
            label="Investment Year"
          />
        </div>
      </div>
      <LoadAndSaveFilters
        donorNames={donorNames}
        relationships={relationships}
        portfolioNames={portfolioNames}
        cycles={cycles}
        status={status}
        trueImpactStaff={trueImpactStaff}
        dueDates={dueDates}
        charityNavigator={charityNavigator}
        years={years}
        sortBy={sortBy}
        anyFiltersApplied={anyFiltersApplied}
        handleApplyAllFilters={handleApplyAllFilters}
      />
      <div className="applied_sort__wrapper">
        <FeedbackDashboardAppliedFilters
          donorNames={donorNames}
          relationships={relationships}
          portfolioNames={portfolioNames}
          cycles={cycles}
          status={status}
          trueImpactStaff={trueImpactStaff}
          dueDates={dueDates}
          charityNavigator={charityNavigator}
          years={years}
          sortBy={sortBy}
        />
        <button
          onClick={handleClearAllFilters}
          className="clear-filters"
          disabled={!anyFiltersApplied}
        >
          Clear Filters
        </button>
        <div className="sort__wrapper">
          <div className="heading-label">Sort By</div>
          <FeedbackSingleSelectFilter
            showClearAll={false}
            feedbackFilter={sortBy}
            icon={faArrowDownShortWide}
            defaultValue="Program Name by A-Z"
          />
        </div>
      </div>
    </div>
  );
};

export default React.memo(FiltersBar);
